import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Aplica o tema salvo antes do primeiro render para evitar flash
const savedTheme = localStorage.getItem('theme') || 'dark';
document.documentElement.setAttribute('data-theme', savedTheme);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
